export const getPercentageValue = (part, whole) => {
  if (
    !(typeof part !== 'number' && typeof whole !== 'number') ||
    !((isNaN(parseFloat(part)) && isNaN(parseFloat(whole))) || whole !== 0)
  ) {
    const percentage = parseFloat(part) / parseFloat(whole) * 100;
    return parseFloat(percentage.toFixed(2));
  }
  return 0;
};

export const getActiveSeatCount = (disableSeatCount, ttl_seat) => {
  const activeSeat = disableSeatCount ? ttl_seat - disableSeatCount : ttl_seat;
  return activeSeat;
};

export const getMajorityCount = (disableSeatCount, ttl_seat) =>
  disableSeatCount
    ? Math.floor((ttl_seat - disableSeatCount) / 2) + 1
    : Math.floor(ttl_seat / 2) + 1;

export function getExitPollDataForState(data) {
  const sourceDataMap = {};
  if (
    typeof data !== 'object' ||
    !data ||
    !Array.isArray(data.al_rslt) ||
    data.al_rslt.length === 0
  ) {
    return {};
  }
  const electionData = data.al_rslt;
  const len = electionData.length;
  let sourceData;
  let curParty;
  for (let counter = 0; counter < len; counter += 1) {
    sourceData = electionData[counter];
    let meanTotal = 0;
    if (sourceData && Array.isArray(sourceData) && sourceData.length > 0) {
      for (
        let partyCounter = 0;
        partyCounter < sourceData.length;
        partyCounter += 1
      ) {
        curParty = sourceData[partyCounter];
        if (curParty) {
          meanTotal += (curParty.ls + curParty.wsc) / 2;
        }
      }
      for (
        let partyCounter = 0;
        partyCounter < sourceData.length;
        partyCounter += 1
      ) {
        curParty = sourceData[partyCounter];
        // Not to show the source if does not have any result removed meanTotal from condition
        if (curParty) {
          if (!sourceDataMap[curParty.src]) {
            sourceDataMap[curParty.src] = [];
          }
          const mean = (curParty.ls + curParty.wsc) / 2;
          sourceDataMap[curParty.src].push({
            an: curParty.an,
            color: curParty.cc,
            ws: meanTotal > 0 ? curParty.ws || 0 : '-',
            ls: meanTotal > 0 ? curParty.ls || 0 : '-',
            wsc: meanTotal > 0 ? curParty.wsc || 0 : '-',
            lsws: meanTotal > 0 ? (curParty.ws || 0) + (curParty.ls || 0) : '-',
            // Not to show the source if does not have any result
            wscp: meanTotal > 0 ? mean * 100 / meanTotal : 0,
          });
        }
      }
    }
  }

  return { sourceDataMap, ttl_seat: data.ttl_seat };
}

export const shiftOthToRight = sortedPartyData => {
  let index1;
  if (
    sortedPartyData &&
    Array.isArray(sortedPartyData) &&
    sortedPartyData.length > 1
  ) {
    sortedPartyData.map((item, index) => {
      if (item.an === 'OTH') {
        index1 = index;
      }
      return index1;
    });
    if (index1 !== undefined) {
      const othData = sortedPartyData.splice(index1, 1);
      sortedPartyData.push(othData[0]);
    }
  }
  return sortedPartyData;
};

export const compareSeats = (a, b) => b.ls + b.ws - (a.ls + a.ws);

export const compareSeatsExitPolls = (a, b) => b.wscp - a.wscp;

export const getPartyListInSortedOrder = (data, isExitPoll) => {
  if (data && Array.isArray(data) && data.length > 0) {
    if (!isExitPoll) {
      data.sort(compareSeats);
    }
    data.sort(compareSeatsExitPolls);
  }
  return data;
};

export const arrayToHashMap = (arr, key = 'an') => {
  const hashMap = {};
  if (arr && Array.isArray(arr)) {
    arr.forEach(item => {
      if (item?.[key]) {
        hashMap[item[key]] = item;
      }
    });
  }

  return hashMap;
};

export function getSourceDataforExitPoll(sourceData, state, ttl_seat) {
  const keys = sourceData ? Object.keys(sourceData) : [];

  let finalKeys = [];
  const finalSourceData = {};
  keys.map(item => {
    // Not to show the source if does not have any result
    // const totalWonSeats =
    //   sourceData[item] && Array.isArray(sourceData[item])
    //     ? sourceData[item].reduce((total, source) => ({
    //         wscp: total.wscp + source.wscp,
    //       }))
    //     : {};
    if (state?.tableView && state?.tableView !== '0' && sourceData[item]) {
      finalSourceData[item] = JSON.parse(
        JSON.stringify(shiftOthToRight(sourceData[item])),
      );
      finalSourceData[item] = arrayToHashMap(finalSourceData[item]);
    } else if (sourceData[item]) {
      finalSourceData[item] = JSON.parse(
        JSON.stringify(
          shiftOthToRight(getPartyListInSortedOrder(sourceData[item], true)),
        ),
      );
    }

    // Not to show the source if does not have any result
    // if (totalWonSeats.wscp > 0) {
    // }
    finalKeys.push(item);
    return finalKeys;
  });

  if (finalKeys.length > 0) {
    finalKeys = finalKeys.map(item => ({ name: item }));
    return {
      exitPollSource: finalKeys,
      selectedSource: finalKeys[0],
      finalSourceData,
      activeSeats: getActiveSeatCount(state?.disableSeatCount, ttl_seat),
      majority: getMajorityCount(state?.disableSeatCount, ttl_seat),
    };
  }
  return {
    exitPollSource: [],
    selectedSource: '',
    finalSourceData: null,
    activeSeats: sourceData?.ttl_seat,
    majority: getMajorityCount(state?.disableSeatCount, sourceData?.ttl_seat),
  };
}

export function filteredDataForExitPoll(data, states) {
  const data1 = {};
  if (states && Array.isArray(states) && states.length) {
    states.forEach(item => {
      if (item?.key) {
        data1[item?.key] = getExitPollDataForState(data[item?.key]);
      }
    });
    return data1;
  }
  return [];
}

export function getExitPollDataForStates(data, states) {
  const data1 = {};
  if (states && Array.isArray(states) && states.length) {
    states.forEach(item => {
      if (item?.key) {
        data1[item.key] = getSourceDataforExitPoll(
          data[item.key]?.sourceDataMap,
          item,
          data[item.key]?.ttl_seat,
        );
      }
    });
    return data1;
  }
  return [];
}

export const getCountOfLeadPlusWins = data => {
  const seatCount = { winCount: 0, leadPlusWinCount: 0 };
  const party = data ? Object.keys(data) : [];
  for (let counter = 0; counter < party.length; counter += 1) {
    seatCount.leadPlusWinCount +=
      data?.[party[counter]]?.ls + data?.[party[counter]]?.ws || 0;
    seatCount.winCount += data?.[party[counter]]?.ws || 0;
  }
  if (isNaN(seatCount.winCount)) {
    seatCount.winCount = 0;
  }
  if (isNaN(seatCount.leadPlusWinCount)) {
    seatCount.leadPlusWinCount = 0;
  }
  return seatCount;
};

export const getLeadingParty = (
  sortedPartyData,
  ttl_seat,
  config,
  leadingPartyData = null,
) => {
  let leadingPartyObj = {};
  if (
    !Array.isArray(sortedPartyData) ||
    (sortedPartyData && sortedPartyData.length === 0)
  ) {
    return leadingPartyObj;
  }
  const majority = config?.disableSeatCount
    ? Math.floor((ttl_seat - config.disableSeatCount) / 2) + 1
    : Math.floor(ttl_seat / 2) + 1;
  const [
    firstPartyData = { ws: 0, ls: 0 },
    secondPartyData = { ws: 0, ls: 0 },
  ] = [...sortedPartyData];
  const totalWonSeats =
    sortedPartyData && Array.isArray(sortedPartyData)
      ? sortedPartyData.reduce((total, partyData) => ({
          ws: total.ws + partyData.ws,
        }))
      : {};

  ttl_seat = config?.disableSeatCount
    ? ttl_seat - config?.disableSeatCount
    : ttl_seat;

  if (firstPartyData.ws >= majority) {
    //First party WON
    leadingPartyObj = {
      party: firstPartyData?.an || '',
      text: 'WON',
      color: firstPartyData?.cc || '#A5A5A5',
    };
  } else if (totalWonSeats.ws === ttl_seat && firstPartyData.ws < majority) {
    //Election over but Hung assembly
    leadingPartyObj = {
      party: 'HUNG',
      text: 'ASSEMBLY',
      color: '#595959',
    };
  } else if (
    firstPartyData.ws + firstPartyData.ls > majority ||
    firstPartyData.ws + firstPartyData.ls >
      secondPartyData.ws + secondPartyData.ls
  ) {
    //First party LEADING
    leadingPartyObj = {
      party: firstPartyData?.an || '',
      text: 'LEADING',
      color: firstPartyData.cc || '#A5A5A5',
    };
  }
  if (
    leadingPartyData?.party &&
    leadingPartyData?.party !== 'HUNG' &&
    leadingPartyObj?.party === 'HUNG'
  ) {
    leadingPartyObj = leadingPartyData;
  }
  if (leadingPartyObj.party === 'OTH') {
    leadingPartyObj = {};
  }
  return leadingPartyObj;
};

export const getAllianceMap = (partyData, allianceData) => {
  const allianceMap = {};
  const finalAllianceMap = [];
  if (partyData && Array.isArray(partyData) && partyData.length > 0) {
    partyData.map(item => {
      if (item.al_id && item.al_id !== 1) {
        allianceMap[item.al_id] = allianceMap[item.al_id] || [];
        allianceMap[item.al_id].push(item);
      }
      return allianceMap;
    });
  }
  if (allianceData && Array.isArray(allianceData) && allianceData.length > 0) {
    allianceData.map(item => {
      if (allianceMap[item.a_id] && item.an) {
        finalAllianceMap.push({
          name: item.an,
          color: item.cc,
          data: allianceMap[item.a_id],
          totalSeats: item.ls + item.ws,
        });
      }
      return finalAllianceMap;
    });
  }
  return finalAllianceMap;
};

export const getSortedViewData = (data, state) => {
  if (
    data &&
    Array.isArray(data.al_rslt) &&
    data.al_rslt.length > 0 &&
    data.al_rslt[0] &&
    Array.isArray(data.pg_rslt) &&
    data.pg_rslt.length > 0 &&
    data.pg_rslt[0]
  ) {
    const alResult = data.pg_rslt[0];
    const prResult = data.al_rslt[0];
    let allianceMap = {};
    let sortedPartyViewData = getPartyListInSortedOrder(prResult);
    let sortedAllianceViewData = getPartyListInSortedOrder(alResult);
    const leadingAllianceObj = getLeadingParty(
      sortedAllianceViewData,
      data.ttl_seat,
      state,
    );
    const leadingPartyObj = getLeadingParty(
      sortedPartyViewData,
      data.ttl_seat,
      state,
      leadingAllianceObj,
    );
    if (
      data?.pr_rslt &&
      Array.isArray(data.pr_rslt) &&
      data.pr_rslt.length > 0
    ) {
      allianceMap = getAllianceMap(data.pr_rslt, sortedAllianceViewData);
    }
    const activeSeats = getActiveSeatCount(
      state?.disableSeatCount,
      data?.ttl_seat,
    );
    const countOfLeadPlusWins = getCountOfLeadPlusWins(sortedPartyViewData);
    sortedPartyViewData = shiftOthToRight(sortedPartyViewData);
    sortedAllianceViewData = shiftOthToRight(sortedAllianceViewData);
    const sortedData = {
      sortedPartyViewData,
      sortedAllianceViewData,
      leadingPartyObj,
      leadingAllianceObj,
      allianceMap,
      activeSeats,
      countOfLeadPlusWins,
      majority: getMajorityCount(state?.disableSeatCount, data?.ttl_seat),
    };
    return sortedData;
  }

  return {
    sortedPartyViewData: [],
    sortedAllianceViewData: [],
    leadingAllianceObj: {},
    leadingPartyObj: {},
    allianceMap: {},
    activeSeat: data?.ttl_seat,
    countOfLeadPlusWins: { winCount: 0, leadPlusWinCount: 0 },
    majority: getMajorityCount(state?.disableSeatCount, data?.ttl_seat),
  };
};

export const getSingleSortedViewData = (data, state) => {
  if (
    data?.al_rslt &&
    Array.isArray(data.al_rslt) &&
    data.al_rslt.length > 0 &&
    data.al_rslt[0]
  ) {
    const prResult = data.al_rslt[0];
    let sortedPartyViewData = getPartyListInSortedOrder(prResult);
    const leadingPartyObj = getLeadingParty(
      sortedPartyViewData,
      data.ttl_seat,
      state,
    );
    const activeSeats = getActiveSeatCount(
      state?.disableSeatCount,
      data?.ttl_seat,
    );
    const lastYearActiveSeats =
      sortedPartyViewData && Array.isArray(sortedPartyViewData)
        ? sortedPartyViewData.reduce((acc, party) => {
            acc += party.pws;
            return acc;
          }, 0)
        : 0;
    const countOfLeadPlusWins = getCountOfLeadPlusWins(sortedPartyViewData);
    sortedPartyViewData = shiftOthToRight(sortedPartyViewData);
    const sortedData = {
      sortedPartyViewData,
      leadingPartyObj,
      activeSeats,
      countOfLeadPlusWins,
      lastYearActiveSeats,
      lastYearMajority: getMajorityCount(0, lastYearActiveSeats),
      majority: getMajorityCount(state?.disableSeatCount, data?.ttl_seat),
    };
    return sortedData;
  }

  return {
    sortedPartyViewData: [],
    sortedAllianceViewData: [],
    leadingAllianceObj: {},
    leadingPartyObj: {},
    allianceMap: {},
    activeSeat: data?.ttl_seat,
    countOfLeadPlusWins: { winCount: 0, leadPlusWinCount: 0 },
    majority: getMajorityCount(state?.disableSeatCount, data?.ttl_seat),
  };
};

export const getSortedViewDataForStates = (data, states) => {
  const data1 = {};
  if (states && Array.isArray(states) && states.length) {
    states.forEach(item => {
      if (item?.key) {
        data1[item.key] = getSortedViewData(data[item.key], item);
      }
    });
    return data1;
  }
  return [];
};

export const getSortedViewDataForSingleState = (data, states) => {
  const data1 = {};
  if (states && Array.isArray(states) && states.length) {
    states.forEach(item => {
      if (item?.key) {
        data1[item.key] = getSingleSortedViewData(data[item.key], item);
      }
    });
    return data1;
  }
  return [];
};
